import NoFunds from './noFunds'
import AccessPay from './accessPay'
import useGetFunds from './hooks/useGetFunds'
import DotsLoading from 'components/loadings/dotsLoading'
import MoneyPools from './moneyPools'
import CashBoxes from './cashBoxes'

export default function Funds() {
    const { moneyPools, cashBoxes, isLoading } = useGetFunds()
    return (
        <>
            {isLoading ? (
                <DotsLoading />
            ) : (
                <div>
                    {!moneyPools ? (
                        <DotsLoading />
                    ) : moneyPools.length > 0 ? (
                        <div className="pb-16">
                            <AccessPay />
                            <div className="mx-4 ">
                                {cashBoxes && (
                                    <CashBoxes cashBoxes={cashBoxes} />
                                )}
                                <MoneyPools moneyPools={moneyPools} />
                            </div>
                        </div>
                    ) : (
                        <NoFunds />
                    )}
                </div>
            )}
        </>
    )
}
